<template>
    <div class="d-flex flex-column flex-column-fluid">
        <!--begin::Content-->
        <div class="d-flex flex-column flex-column-fluid text-center p-10 py-lg-15">
            <!--begin::Logo-->
            <router-link to="/dashboard" class="mb-10 pt-lg-10">
                <img alt="Logo" :src="require('@/assets/images/logo.png')" class="h-40px mb-5"/>
            </router-link>
            <!--end::Logo-->

            <!--begin::Wrapper-->
            <div class="pt-lg-10 mb-10">
                <!--begin::Logo-->
                <h1 class="fw-bolder fs-4x text-gray-800 mb-10">{{$t('sorry')}}</h1>
                <!--end::Logo-->

                <!--begin::Message-->
                <div class="fw-bold fs-3 text-muted mb-15">
                    {{$t('no_access_login')}}
                </div>
                <!--end::Message-->

                <!--begin::Action-->
                <div class="text-center">
                    <router-link to="/" class="btn btn-lg btn-danger fw-bolder"
                    >{{$t('back_home')}}
                    </router-link
                    >
                </div>
                <!--end::Action-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Content-->

    </div>
</template>

<script lang="ts">
  import { defineComponent, onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';

  export default defineComponent({
    name: 'error-500',
    components: {},
    setup() {
      const store = useStore();

      onMounted(() => {
        store.dispatch(Actions.ADD_BODY_CLASSNAME, 'bg-body');
      });

      onUnmounted(() => {
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'bg-body');
      });
    },
  });
</script>
